var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isVisible
    ? _c("dialog", { staticClass: "c-modal" }, [
        _c("div", { staticClass: "c-modal__inner" }, [
          _vm.closeButton
            ? _c(
                "button",
                {
                  staticClass: "c-modal__close",
                  attrs: { type: "button" },
                  on: { click: _vm.closeModal }
                },
                [
                  _c("span", [_vm._v("Close")]),
                  _vm._v(" "),
                  _c(
                    "svg",
                    {
                      staticClass: "c-modal__close-icon",
                      attrs: { "aria-hidden": "true", focusable: "false" }
                    },
                    [
                      _c("use", {
                        attrs: {
                          "xmlns:xlink": "http://www.w3.org/1999/xlink",
                          "xlink:href": "#close-circle"
                        }
                      })
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "c-modal__content",
              class: { "c-modal__content--closable": _vm.closeButton }
            },
            [
              _c("h2", { staticClass: "c-modal__title" }, [
                _vm._v("\n        " + _vm._s(_vm.title) + "\n      ")
              ]),
              _vm._v(" "),
              _vm.description
                ? _c("p", { staticClass: "c-modal__description" }, [
                    _vm._v(_vm._s(_vm.description))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "c-modal__body" },
                [_vm._t("default")],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "c-modal__footer" },
                [_vm._t("footer")],
                2
              )
            ]
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-06fda934", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06fda934","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/consumer/_contact-us-rap/_vue/Modal.vue
// module id = 749
// module chunks = 0